import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface IReview {
  ratingId: number;
  userId?: number;
  userName?: string;
  productId?: number;
  productTitle?: string;
  rating: number;
  comment?: string;
  createdAt?: string;
  images?: string[];
  [key: string]: any;
}

const getAllReviews = () => {
  return Axios.get<any>(ENDPOINTS.reviews.all);
};

const getReviewsByUser = (userId: number) => {
  return Axios.get<any>(ENDPOINTS.reviews.byUser(userId));
};

const deleteReview = (ratingId: number) => {
  return Axios.delete<any>(ENDPOINTS.reviews.byId(ratingId));
};

const ReviewService = { getAllReviews, getReviewsByUser, deleteReview };

export default ReviewService;
